import { BinderSectionData } from '../hooks/useBinderSectionData';
import {
  APIPersonalAutoApplicationFormDriver,
  APIBinderData,
} from 'types/api.types';
import {
  countPrincipalDrivers,
  getInsuranceSourceLabel,
} from '../utils/helpers';

export const processListedDriversData = (
  binderReportData: APIBinderData,
): BinderSectionData => {
  const applicationData = binderReportData?.application_data;
  const mvrData = binderReportData?.mvr_data || [];
  const quoteData = binderReportData?.quote_data;
  const applicationDrivers = applicationData?.drivers || [];
  const quoteDrivers = quoteData?.drivers || [];
  const insuranceData = binderReportData?.insurance_data?.data;
  const insuranceSource = binderReportData?.insurance_data?.source;

  const processedDrivers = applicationDrivers.map(
    (driver: APIPersonalAutoApplicationFormDriver, index: number) => {
      const prevInsurancePolicy = insuranceData?.[index]?.policies[0];
      // Get corresponding MVR data
      const mvrDriver = mvrData?.[index];
      // Get corresponding Quote data
      const quoteDriver = quoteDrivers[index];

      // Get AutoPlus date (from quote data)
      const autoPlusDate = quoteDriver.date_insured
        ? quoteDriver.date_insured
        : 'N/A';

      return {
        // Row 1 - Name
        name: driver.name || 'N/A',

        // Row 2 - License info
        driversLicenseNumber: driver.license || 'N/A',
        licenseClass: driver.license_class,
        principal: countPrincipalDrivers(quoteData, driver),
        excluded: 'N/A', // Not found in data

        // Row 3 - Dates and Status
        mvrDate: mvrDriver?.request_date || 'N/A',
        status: mvrDriver?.status || 'N/A',
        autoPlusDate: autoPlusDate,

        // Row 4 - Experience
        years: 'N/A', // Not found in data
        months: 'N/A', // Not found in data
        gaps: quoteDriver.gaps,

        // Row 5 - Previous Insurance
        previousCompany: prevInsurancePolicy?.carrier,
        previousPolicyNumber: prevInsurancePolicy?.policy,
        effectiveDateTime: prevInsurancePolicy?.recorded_start_date,
        expiryDateTime:
          prevInsurancePolicy?.cancellation_date ||
          prevInsurancePolicy?.recorded_end_date,

        // Row 6 - Declarations
        opcf28a: 'N/A', // Not found in data
        retireeDeclaration: driver.is_retiree_discount ? 'Yes' : 'No',
      };
    },
  );

  const isValid = processedDrivers.length > 0;
  const message =
    processedDrivers.length > 0
      ? `${processedDrivers.length} driver(s) listed`
      : 'No drivers found';

  return {
    title: 'Listed Drivers',
    description: 'Complete driver information and verification status summary.',
    isValid,
    message,
    data: {
      insuranceSource: getInsuranceSourceLabel(insuranceSource),
      drivers: processedDrivers,
      driverCount: processedDrivers.length,
    },
  };
};
